import React from "react";

import { Flex, Text } from "@chakra-ui/react";

const NaoPossui = ({ title }) => {
  return (
    <Flex w="100%" py="12px" justifyContent="start">
      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color="#797A80">
        Não Possui
      </Text>
    </Flex>
  );
};

export default NaoPossui;
